/// <amd-module name="Repos/Views/PullRequest/RestClient/WorkItemTracking" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\pr-details\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as WorkItemTracking from "Repos/Views/PullRequest/Contracts/WorkItemTracking";

export interface IWorkItemTrackingRestClient extends IVssRestClient {
    /**
     * Returns the next state on the given work item IDs.
     * 
     * @param ids - list of work item ids
     * @param action - possible actions. Currently only supports checkin
     */
    getWorkItemNextStatesOnCheckinAction(ids: number[], action?: string): Promise<WorkItemTracking.WorkItemNextStateOnTransition[]>;
}

class WorkItemTrackingRestClient extends RestClientBase implements IWorkItemTrackingRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Returns the next state on the given work item IDs.
     * 
     * @param ids - list of work item ids
     * @param action - possible actions. Currently only supports checkin
     */
    public async getWorkItemNextStatesOnCheckinAction(
        ids: number[],
        action?: string
        ): Promise<WorkItemTracking.WorkItemNextStateOnTransition[]> {

        const queryValues: any = {
            ids: ids && ids.join(","),
            action: action
        };

        return this.beginRequest<WorkItemTracking.WorkItemNextStateOnTransition[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/wit/workItemTransitions",
            queryParams: queryValues
        });
    }

}

export const WorkItemTrackingClientName = "Repos.PRDetails.WitTracking.IWorkItemTrackingRestClient";

export function getWorkItemTrackingClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IWorkItemTrackingRestClient {
    return pageContext.getRestClient<IWorkItemTrackingRestClient>(WorkItemTrackingClientName, options);
}

RestClients.add(WorkItemTrackingClientName, { 
    factory: WorkItemTrackingRestClient,
    options: {
        resourceAreaId: "5264459e-e5e0-4bd8-b118-0985e68a4ec5",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
